import { render, staticRenderFns } from "./businessGrowth.vue?vue&type=template&id=90e1608c&scoped=true&"
import script from "./businessGrowth.vue?vue&type=script&lang=js&"
export * from "./businessGrowth.vue?vue&type=script&lang=js&"
import style0 from "./businessGrowth.vue?vue&type=style&index=0&id=90e1608c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e1608c",
  null
  
)

export default component.exports